import { AppBar, Box, Button, CircularProgress, Dialog, IconButton, List, ListItem, ListItemSecondaryAction, Toolbar, Typography } from '@mui/material'
import React, { Component } from 'react'
import Scrollbar from 'react-scrollbars-custom'
import Service from '../../../config/networkutils';
import { getCookie } from '../../../utils/CookieHelper';
import { getSecondaryColor } from '../../Helper/CommonThings';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@material-ui/icons/Close';
import UploadIcon from '@material-ui/icons/CloudUpload'
import PRPTemplate from '../../PRPTemplate/PRPTemplate';
import { withSnackbar } from 'notistack';

const token = getCookie("ptd_ts_token");
const user = JSON.parse(getCookie("ptd_ts_user"))


class CompletedProjectsList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            isLoading: true,
            copyData: [],
            showCompletedAll: false,
            selectedOppurtunity: {},
            open: false,
        }
        this.PRPTemplateRef = React.createRef()
    }

    componentDidMount() {
        const height = this.divElement.clientHeight;
        if (!this.state.isLoading) {
            this.setState({ height: height });
        }
        this.getData()
    }

    getData() {
        Service.get(`/api/crm/user/pref/get_completed_projects/?stage=3&is_trashed=False`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    data: res.data,
                    copyData: res.data,
                }, () => {
                    this.setState({
                        isLoading: false
                    })
                })
            }).catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    screenSizeCheck() {
        if (window.innerWidth > 1600) {
            return true
        } else {
            return false
        }
    }

    showAllCompletedData(popupState) {
        this.setState({
            data: this.state.copyData,
            showCompletedAll: false
        })
        popupState.close()
    }

    completedSearch(data) {
        const data_lowercase = data.toLowerCase()
        var search_words = data_lowercase.split(" ");
        search_words = search_words.filter(n => n)
        var filtered_data = []
        if (search_words.length === 0) {
            filtered_data = this.state.copyData
        }

        for (let i = 0; i < this.state.copyData.length; i++) {
            const element = this.state.copyData[i];
            var num_of_passed = false
            for (let j = 0; j < search_words.length; j++) {
                const el = search_words[j];
                num_of_passed = element.name.toLowerCase().includes(el)
                if (!num_of_passed) {
                    break
                }
            }
            if (num_of_passed) {
                filtered_data.push(element)
            }
        }
        this.setState({ data: filtered_data })
        if (data.length > 0) {
            this.setState({
                showCompletedAll: true
            })
        } else {
            this.setState({
                showCompletedAll: false
            })
        }
    }

    getOpportunity(item) {
        this.setState({
            selectedOppurtunity: item,
            open: true
        })
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    postFavourite(rowData) {
        if ('crm_user_pref_id' in rowData) {
            let obj = {
                "is_favourite": !rowData.is_favourite,
                'created_by': user.id
            }
            Service.patch(`/api/crm/user/pref/${rowData.crm_user_pref_id}/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: obj,
            })
                .then(res => {
                    this.getData()
                })
                .catch(error => {
                    this.setState({ isLoading: false })
                    console.log(error)
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                })
        } else {
            let obj = {
                "crm": rowData.id,
                "ptd_employee": user.id,
                "is_favourite": !rowData.is_favourite,
                "created_by": user.id
            }
            Service.post(`/api/crm/user/pref/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: obj,
            })
                .then(res => {
                    this.getData()
                })
                .catch(error => {
                    this.setState({ isLoading: false })
                    console.log(error)
                    // this.props.enqueueSnackbar('Something went wrong!', {
                    //     variant: 'error'
                    // });
                })

        }
    }

    render() {
        const access = this.props.access.access
        return (
            <div ref={(divElement) => { this.divElement = divElement }}>
                <Box >
                    <Box sx={{ height: window.innerHeight - 165 }}>
                        {this.state.isLoading ?
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress color="secondary" /></Box> :
                            <Box>
                                <Scrollbar style={{ width: this.screenSizeCheck() ? '22vw' : window.innerWidth - (window.innerWidth / 1.48), height: window.innerHeight - 175 }}>
                                    <List>
                                        {this.state.data.map((item, index) => {
                                            return (
                                                <ListItem key={index} button onClick={() => this.getOpportunity(item)} >
                                                    {item.name}
                                                    <ListItemSecondaryAction>
                                                        <IconButton edge="end" onClick={() => this.postFavourite(item)}>
                                                            {item.is_favourite ? <StarIcon style={{ color: getSecondaryColor() }} /> : <StarBorderIcon style={{ color: getSecondaryColor() }} />}
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            )
                                        })
                                        }
                                    </List>
                                </Scrollbar>
                            </Box>
                        }
                    </Box>
                </Box>
                <Dialog fullScreen open={this.state.open} onClose={this.handleClose}>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Box display={'flex'} flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                <Box flexGrow={1} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                    <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6">
                                        {this.state.selectedOppurtunity.name}
                                    </Typography>
                                </Box>
                                {access.l6a && access.l6a.l6a_c ?
                                    <Button
                                        variant="oultined"
                                        color="inherit"
                                        onClick={() => { if (this.PRPTemplateRef.current) this.PRPTemplateRef.current.openBulkUpload() }}
                                        size='small'
                                        startIcon={<UploadIcon />}>
                                        Upload PRP Data Excel
                                    </Button>
                                    : null}
                            </Box>
                        </Toolbar>
                    </AppBar>
                    <Box margin={2} marginTop={1}>
                        <PRPTemplate
                            ref={this.PRPTemplateRef}
                            project={this.state.selectedOppurtunity}
                            // closeModal={this.handleClose} 
                            addPRPAccess={access.l6a && access.l6a.l6a_b}
                            editPRPAccess={access.l6a && access.l6a.l6a_c}
                            uploadPRPAccess={access.l6a && access.l6a.l6a_c}
                            deletePRPAccess={access.l6a} />
                    </Box>
                </Dialog>

            </div>

        )
    }
}

export default withSnackbar(CompletedProjectsList);
